module.exports = __webpack_public_path__ + "img/3.18c5dec7.png";